export const accessibilitySpeakingRates: number[] = [
  0.75, 0.85, 1, 1.25, 1.5, 1.75, 2,
];
